import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { STORAGE_KEYS } from '@/lib/constants';

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // The admin console is an internal tool — no marketing/analytics consent UI
    // there (it also overlapped case-action areas). Checked at mount only; this
    // component lives outside the router, so it can't observe SPA navigations.
    if (window.location.pathname.startsWith('/admin')) return;
    const choice = localStorage.getItem(STORAGE_KEYS.cookieConsent);
    if (!choice) setVisible(true);
  }, []);

  if (!visible) return null;

  const decide = (value: 'accepted' | 'rejected') => {
    localStorage.setItem(STORAGE_KEYS.cookieConsent, value);
    setVisible(false);
  };

  // This component renders as a sibling of <RouterProvider>, so we use a plain
  // <a> instead of react-router's <Link> — no router context is available here.
  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-2xl rounded-xl border border-(--color-border) bg-(--color-card) p-4 shadow-2xl animate-in"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-(--color-muted-foreground)">
          We use cookies to keep you signed in, remember preferences, and improve Tally.{' '}
          <a href="/cookies" className="text-(--color-primary) hover:underline">
            Learn more
          </a>
          .
        </p>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" onClick={() => decide('rejected')}>
            Reject
          </Button>
          <Button size="sm" onClick={() => decide('accepted')}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
